/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DictionaryEntryDto } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class TaskStatusController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags task-status-controller
   * @name ApiV1TaskStatusesViewsDictionaryUsingGet
   * @summary viewDictionary
   * @request GET:/api/v1/task-statuses/views/dictionary
   * @secure
   */
  apiV1TaskStatusesViewsDictionaryUsingGet = (params: RequestParams = {}) =>
    this.request<DictionaryEntryDto[], void>({
      path: `/api/v1/task-statuses/views/dictionary`,
      method: "GET",
      secure: true,
      ...params,
    });
}
